import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cmc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const buildFileUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${API}/files/${path}`;
};

export const WHATSAPP_NUMBER = "393207161253";
export const OWNER_PHONE = "+39 3207161253";
export const OWNER_EMAIL = "cmcautomobili@gmail.com";
export const LOCATION = "Altamura (BA)";

export const whatsappLink = (message = "") => {
  const text = encodeURIComponent(message || "Ciao LC Auto, vorrei maggiori informazioni.");
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
};

export const formatEuro = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

export const formatKm = (n) =>
  new Intl.NumberFormat("it-IT").format(n || 0) + " km";
